import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { GetPostResponse } from '@app/blog/interfaces/get-post-response';
import { GetPostsResponse } from '@app/blog/interfaces/get-posts-response';
import { Post } from '@app/blog/interfaces/post';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BlogService {
  constructor(private readonly httpClient: HttpClient) {}

  getPosts(): Observable<GetPostsResponse> {
    return this.httpClient
      .get<GetPostsResponse>(`${environment.ghostApiUrl}/content/posts/`)
      .pipe(this.setFeatureImageAltDefaultValue<GetPostsResponse>());
  }

  getPost(slug: string): Observable<GetPostResponse> {
    return this.httpClient
      .get<GetPostResponse>(
        `${environment.ghostApiUrl}/content/posts/slug/${slug}/`
      )
      .pipe(this.setFeatureImageAltDefaultValue<GetPostResponse>());
  }

  private setFeatureImageAltDefaultValue<
    T extends GetPostResponse | GetPostsResponse
  >() {
    return map((response: T) => {
      return {
        ...response,
        posts: response.posts.map((post) => {
          return {
            ...post,
            feature_image_alt:
              post.feature_image_alt ??
              post.title.trimEnd() + '_feature_image_alt',
          } as Post;
        }),
      };
    });
  }
}
